module.exports = __webpack_public_path__ + "img/xsweblogo-08.84253539.png";